var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondAndJewellery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FEF0ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8558 18.495L25.1558 15.495C25.0147 15.3387 24.8423 15.2138 24.6498 15.1285C24.4572 15.0432 24.2489 14.9995 24.0383 15H18.0008C17.7903 14.9995 17.5819 15.0432 17.3894 15.1285C17.1968 15.2138 17.0244 15.3387 16.8833 15.495L14.1833 18.495C13.9346 18.7706 13.7969 19.1287 13.7969 19.5C13.7969 19.8713 13.9346 20.2294 14.1833 20.505L20.4833 27.5025C20.5536 27.5798 20.6393 27.6416 20.7349 27.6839C20.8305 27.7262 20.9338 27.7481 21.0383 27.7481C21.1428 27.7481 21.2462 27.7262 21.3418 27.6839C21.4374 27.6416 21.523 27.5798 21.5933 27.5025L27.8933 20.505C28.137 20.2248 28.2681 19.8641 28.2611 19.4928C28.2542 19.1215 28.1098 18.766 27.8558 18.495Z",
    fill: "#BC030E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondAndJewellery);
export default __webpack_public_path__ + "static/media/diamond_and_jewellery.2349da9be3bbdafeabce023f96afc652.svg";
export { ForwardRef as ReactComponent };